module.exports = {"ru":{"title":"Скачать XLS"},"en":{"title":"Download XLS"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/excel-export/text.yaml
// module id = 136
// module chunks = 0